<template>
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.35" d="M2 9.5C5 7 8.4 5.6 12 5.6C15.6 5.6 19 7 22 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path opacity="0.6" d="M5 13C6.8 11.6 9.3 10.7 12 10.7C14.7 10.7 17.2 11.6 19 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.5 16.5C9.5 15.6 10.7 15.2 12 15.2C13.3 15.2 14.5 15.6 15.5 16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="19.5" r="1" fill="currentColor"/>
        <path d="M3 3L21 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>
